export default __webpack_public_path__ + "static/media/avado-logo-v1.1.60dfafad.svg";